/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps } from 'react';

const SvgPension = (props: SVGProps<SVGSVGElement>) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_pension)" />
    <g transform="translate(8.35, 7.35)" stroke="#F7F5F8" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.65 2.15C12.8887 2.15 10.65 8.86563 10.65 17.1494V17.15C11.8537 15.7269 13.64 14.8131 15.65 14.8131C17.66 14.8131 19.4462 15.7269 20.65 17.1494C20.65 8.86563 18.4112 2.15 15.65 2.15Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.65 2.15C7.36562 2.15 0.65 8.86563 0.65 17.15C1.85375 15.7269 3.64 14.8131 5.65 14.8131C7.66 14.8131 9.44625 15.7269 10.65 17.1494C10.65 8.86563 12.8887 2.15 15.65 2.15Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.65 2.15C18.4112 2.15 20.65 8.86563 20.65 17.1494V17.15C21.8537 15.7269 23.64 14.8131 25.65 14.8131C27.66 14.8131 29.4462 15.7269 30.65 17.15C30.65 8.86563 23.9344 2.15 15.65 2.15Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M15.4 2.15C15.3975 2.15 15.395 2.14777 15.395 2.14441V0.654608C15.395 0.648464 15.405 0.648464 15.405 0.654608V2.14441C15.405 2.14777 15.4025 2.15 15.4 2.15Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.15 30.65C11.7716 30.65 10.65 29.5387 10.65 28.1729C10.65 28.1661 10.6625 28.1661 10.6625 28.1729C10.6625 29.5319 11.7784 30.6376 13.15 30.6376C14.5216 30.6376 15.6375 29.5319 15.6375 28.1729V15.1556C15.6375 15.1481 15.65 15.1481 15.65 15.1556V28.1729C15.65 29.5387 14.5284 30.65 13.15 30.65Z" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_pension" x1="7" y1="4.5" x2="44.5" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#BD63BC" />
        <stop offset="1" stopColor="#611462" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgPension;
